var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 536px;\n  margin: 32px;\n'], ['\n  width: 536px;\n  margin: 32px;\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n']),
  _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n'], ['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n']),
  _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n'], ['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n']),
  _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n']),
  _templateObject7 = _taggedTemplateLiteralLoose(['\n  max-width: 144px;\n'], ['\n  max-width: 144px;\n']);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import styled from 'styled-components';
import { Title, Text, Button, Icon, Link } from '@olxbr/design-system/web';
import PropTypes from 'prop-types';
import { sendEvent } from '../util/tracking';
var DivCustom = styled.div(_templateObject, function (_ref) {
  var mb = _ref.mb,
    color = _ref.color;
  var style = '';
  if (mb) {
    style += 'margin-bottom: ' + mb + 'px;';
  }
  if (color) {
    style += 'color: ' + color + ';';
  }
  return style;
});
var ContainerDiv = styled.div(_templateObject2);
var CloseModal = styled.div(_templateObject3);
var TitleCustom = styled(Title)(_templateObject4);
var TextDiv = styled(Text)(_templateObject5);
var ButtonDiv = styled.div(_templateObject6);
var ButtonWithoutFlex = styled(Button)(_templateObject7);
var AdDeleted = function (_React$Component) {
  _inherits(AdDeleted, _React$Component);
  function AdDeleted() {
    _classCallCheck(this, AdDeleted);
    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }
  AdDeleted.prototype.componentDidMount = function componentDidMount() {
    sendEvent({
      event_type: 'page_view',
      object_detail: 'step_ad_deleted',
      object_name: 'ad_deleting_confirmation'
    });
  };
  AdDeleted.prototype.render = function render() {
    var _this2 = this;
    return React.createElement(ContainerDiv, null, React.createElement(CloseModal, null, React.createElement(Link, {
      href: '',
      onClick: function onClick(e) {
        e.preventDefault();
        _this2.props.closeModal('ad_deleting_confirmation');
      }
    }, React.createElement(Icon, {
      svgPath: 'M13.0606602,12 L18.5303301,17.4696699 C18.8232233,17.7625631 18.8232233,18.2374369 18.5303301,18.5303301 C18.2374369,18.8232233 17.7625631,18.8232233 17.4696699,18.5303301 L12,13.0606602 L6.53033009,18.5303301 C6.23743687,18.8232233 5.76256313,18.8232233 5.46966991,18.5303301 C5.1767767,18.2374369 5.1767767,17.7625631 5.46966991,17.4696699 L10.9393398,12 L5.46966991,6.53033009 C5.1767767,6.23743687 5.1767767,5.76256313 5.46966991,5.46966991 C5.76256313,5.1767767 6.23743687,5.1767767 6.53033009,5.46966991 L12,10.9393398 L17.4696699,5.46966991 C17.7625631,5.1767767 18.2374369,5.1767767 18.5303301,5.46966991 C18.8232233,5.76256313 18.8232233,6.23743687 18.5303301,6.53033009 L13.0606602,12 Z',
      width: 24,
      height: 24
    }))), React.createElement(DivCustom, {
      mb: 8
    }, React.createElement(Icon, {
      svgPath: 'M20.25 11.076a.75.75 0 1 1 1.5 0v.93a10.75 10.75 0 1 1-6.375-9.825.75.75 0 1 1-.61 1.37 9.25 9.25 0 1 0 5.485 8.455v-.93zM11 12.946l10.47-10.47a.75.75 0 1 1 1.06 1.06l-11 11a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l2.47 2.47z',
      width: 40,
      height: 40,
      color: '#00d060'
    })), React.createElement(DivCustom, {
      mb: 8
    }, React.createElement(TitleCustom, null, 'An\xFAncio exclu\xEDdo')), React.createElement(DivCustom, {
      mb: 32
    }, React.createElement(TextDiv, {
      tag: 'span'
    }, 'Agradecemos por anunciar na OLX! N\xE3o se preocupe, seu an\xFAncio ser\xE1 removido em alguns minutos.')), React.createElement(ButtonDiv, null, React.createElement(ButtonWithoutFlex, {
      size: 'medium',
      fluid: true,
      onClick: function onClick() {
        sendEvent({
          event_type: 'click',
          object_detail: 'ok_button',
          object_name: 'ad_deleting_confirmation'
        });
        _this2.props.closeModal();
      }
    }, 'Entendi')));
  };
  return AdDeleted;
}(React.Component);
AdDeleted.propTypes = process.env.NODE_ENV !== "production" ? {
  closeModal: PropTypes.func
} : {};
export default AdDeleted;